import { Box, Grid, Typography, } from '@material-ui/core';
import { CardVotacaoProps } from './card-roadmap-props';
import { DefaultCard } from '../components/default-card';
import { useStyles } from './card-roadmap-styles';
import parse from 'html-react-parser';
import React, { useCallback, useMemo } from 'react';
import { CardRoadmapBtnVotar } from './components/card-roadmap-btn-votar/card-roadmap-btn-votar';
import { toDateString } from 'utils/to-date';

const CardRoadmapComponent = ({
  model,
  onClick,
  selected,
  onClickVote,
  disabled,
  isDiffRevenda,
  index
}: CardVotacaoProps) => {
  const classes = useStyles();

  const parsedDescription = useMemo(() => {
    return parse(model?.descricao ?? '');
  }, [model?.descricao]);

  const handleCardClick = useCallback(() => {
    onClick(model, disabled ?? false);
  }, [onClick, model, disabled]);

  const handleVoteClick = useCallback(async (e: React.MouseEvent) => {
    e.stopPropagation();
    if (disabled) return
    await onClickVote(model.id, model.clickup_id).catch(Boolean);
  }, [disabled, onClickVote, model.id, model.clickup_id]);

  const formattedDate = useMemo(() => {
    return model?.data_cadastro
      ? toDateString(model.data_cadastro, 'DD/MM/YYYY HH:mm')
      : '';
  }, [model?.data_cadastro]);

  return (
    <>
      <DefaultCard
        isSelected={selected}
        onClick={handleCardClick}
        className={classes.card}
      >
        <Grid container spacing={1} className={classes.container} alignItems='center'>
          <Grid item xs="auto">
            <Box minWidth={50}>
              <Typography
                color="primary"
                variant="h4"
                align="center"
              >
                {index + 1}º
              </Typography>
            </Box>
          </Grid>
          <Grid item xs container spacing={1}>
            <Grid item xs={12}>
              <Box>
                <Typography color="textPrimary" variant="body2">
                  <b>{model.titulo}</b>
                </Typography>
              </Box>
              <Typography
                color="textPrimary"
                variant="body1"
                className={classes.descricaoLimitada}
              >
                {parsedDescription}
              </Typography>
            </Grid>
            <Grid item xs>
              <Typography
                color="textSecondary"
                variant="body1"
              >
                {model.clickup_id} - Criado em: {formattedDate}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
        <div className={classes.cardRightButton}>
          <CardRoadmapBtnVotar
            handleVoteClick={handleVoteClick}
            disabled={disabled}
            votado={model.votado}
            porcentagem={model.porcentagem}
            votos={model.votos}
            isDiffRevenda={isDiffRevenda}
          />
        </div>
      </DefaultCard>
    </>
  );
};

CardRoadmapComponent.displayName = 'CardRoadmapComponent';

export const CardRoadmap = React.memo(CardRoadmapComponent);